module.exports = __webpack_public_path__ + "img/barcavela.6b40b22f.svg";